module.exports = __webpack_public_path__ + "static/media/PhoneNumber.a2cdb989.svg";